<template>
    <div class="table-striped">
        <div class="table-box" v-if="!empty && loadStatusTbl">
            <md-table v-model="items" :table-header-color="tableHeaderColor" :md-sort.sync="currentSort" :md-sort-order.sync="currentSortOrder" :md-sort-fn="customSort">
                <md-table-row slot="md-table-row" slot-scope="{ item }">
                    <md-table-cell md-label="Название" md-sort-by="name">{{ item.name }}</md-table-cell>
                    <md-table-cell md-label="Юридическое название" md-sort-by="registry_name">{{ item.registry_name }}</md-table-cell>
                    <md-table-cell md-label="Бин" md-sort-by="tin">{{ item.tin }}</md-table-cell>
                    <md-table-cell md-label="Город" md-sort-by="city">{{ item.city.name }}</md-table-cell>
                    <md-table-cell md-label="Статус" md-sort-by="status">{{ item.status.name }}</md-table-cell>
                    <md-table-cell>
                        <md-avatar>
                            <md-tooltip>Кассы</md-tooltip>
                            <md-icon @click.native="findCashByShop(item.id)" class="md-icon-font-green md-theme-default pointer">crop_portrait</md-icon>
                        </md-avatar>
                        <md-avatar>
                            <md-tooltip>Редактировать</md-tooltip>
                            <md-icon @click.native="editShop(item.id)" class="md-icon-font-green md-theme-default pointer">edit</md-icon>
                        </md-avatar>
                    </md-table-cell>
                </md-table-row>
            </md-table>
            <div class="pagination-block">
                <paginate
                :page-count="this.getCountPage()"
                :click-handler="changePagination"
                :prev-text="''"
                :next-text="''"
                :value="this.getCurrentPage()"
                :container-class="'pagination pagination-no-border pagination-success pagination-primary'">
                </paginate>
            </div>
        </div>

        <div class="loading-overlay" v-if="!loadStatusTbl">
            <md-progress-spinner :md-stroke="2" md-mode="indeterminate"></md-progress-spinner>
        </div>
        <div class="md-empty-state" v-if="empty">
            <h1>Записей не найдено</h1>
        </div>
    </div>
</template>
<script>
import HttpClient from '@/api/calls'

export default {
  name: 'ShopTable',
  props: {
    tableHeaderColor: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      selected: [],
      items: [],
      city: [],
      meta: [],
      empty: true,
      pagination: {
        current_page: 0,
        count_page: 0
      },
      loadStatusTbl: false,
      currentSort: 'name',
      currentSortOrder: 'asc',
      currentSortOld: 'name',
      currentSortOrderOld: 'asc'
    }
  },
  methods: {
    getListShop () {
      this.loadStatusTbl = false
      return HttpClient.httpGet('shop.listAll', this.prepareFilters())
    },
    parseResponse (shopData) {
      if (shopData.meta) {
        this.meta = shopData.meta
        this.setCurrentPage(this.meta.pagination['current_page'])
        this.setCountPage(this.meta.pagination['total_pages'])
      }
      if (shopData.data && shopData.data.length !== 0) {
        this.items = shopData.data
        this.empty = false
      } else {
        this.items = []
        this.empty = true
      }
      this.loadStatusTbl = true
    },
    changePagination (pageNum) {
      if (this.getCurrentPage() === pageNum) {
        return
      }
      this.setCurrentPage(pageNum)
      this.refreshData()
    },
    refreshData () {
      const $this = this
      this.getListShop().then(function (response) {
        $this.parseResponse(response)
      })
    },
    prepareFilters () {
      let params = {}
      params['page'] = this.getCurrentPage()
      params['filter'] = this.$store.state.filtersShop
      if (this.$store.state.search) {
        params['q'] = this.$store.state.search
      }
      params['order'] = {}
      params['order']['method'] = this.currentSortOrder
      params['order']['input'] = this.currentSort
      return params
    },
    editShop (id) {
      this.$store.state.editId = id
      this.$emit('editShop')
    },
    findCashByShop (shopId) {
      this.$emit('setShopId', shopId)
      this.$router.push('/cashbox/' + shopId)
    },
    findUserByShop (shopId) {
      this.$emit('setShopId', shopId)
      this.$router.push('/users/' + shopId)
    },
    customSort (value) {
      if (this.currentSort === this.currentSortOld && this.currentSortOrder === this.currentSortOrderOld) {
        return value
      }
      this.currentSortOld = this.currentSort
      this.currentSortOrderOld = this.currentSortOrder
      this.refreshData()
      return value
    },
    getCurrentPage () {
      return this.$store.state.pagination.current_page
    },
    setCurrentPage (currentPage) {
      this.$store.state.pagination.current_page = currentPage
    },
    getCountPage () {
      return this.$store.state.pagination.count_page
    },
    setCountPage (countPage) {
      this.$store.state.pagination.count_page = countPage
    }
  },
  async created () {
    const $this = this
    let data = await Promise.resolve($this.getListShop())
    if (data) {
      this.parseResponse(data)
    } else {
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shops/ShopTable.vue